import { IConstructorBrowseResponse } from 'shared/types/ConstructorBrowseResponse';

/**
 * [getSearchTermFromConstructorRequest]
 * this method takes in a constructor response and returns the
 * term key (search term to be exact)
 * this is useful if you need to search not based on a query
 * param, but a route value, and have to get the value of the search term
 */

export const getSearchTermFromConstructorRequest = (fallbackData) => {
  if (Array.isArray(fallbackData) && fallbackData.length > 0) {
    const constructorResponse: IConstructorBrowseResponse = fallbackData[0];
    const {
      request: { term },
    } = constructorResponse || { request: {} };

    return term;
  }

  return null;
};
